import React from "react";
import { NavLink } from "react-router-dom";
import "./sidenav.scss";

const Sidenav = () => {
  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");
  const linkData = [
    {
      value: "Objective",
      to: `/?token=${token}`,
      exact: "end",
    },
    {
      value: "Link Initiatives",
      to: `/link-initiatives/?token=${token}`,
    },
    {
      value: "Humanize Work",
      to: `/humanize-work/?token=${token}`,
    },
    {
      value: "Resilience and Analytics (Beta)",
      to: `/resilience-analytics/?token=${token}`,
    },
    {
      value: "Import",
      to: `/import?token=${token}`,
    },
  ];

  return (
    <div className="sidenav-container">
      {linkData.map((navLink) => {
        return (
          <NavLink
            key={navLink.value}
            className="d-block link"
            to={`${navLink.to}`}
            exact
            data-telemetry={`Navigate to ${navLink.value}`}
          >
            {navLink.value}
          </NavLink>
        );
      })}
    </div>
  );
};

export default Sidenav;
